module.exports = "https://cdn-shared.mathletics.com/teacher-modules/student-reports/28/assets/images/81c0cc31e7ed1017a28b861d45efbfba.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/icon_arrow_down.svg
// module id = Njvy
// module chunks = 0